const BLOCK = 'LStudio__app_metric';

/*
    🔥 GRILLA DE MÉTRICAS

    ⚠️ LA CANTIDAD DE COLUMNAS VIAJA COMO CUSTOM PROPERTY INLINE

    Es exactamente el caso que ya arregla _GridGuard.css: una variable
    inline le gana a cualquier media query, así que el CSS responsive
    NO pisa la variable —pisa grid-template-columns directamente—. Si
    algún día tocás esta grilla, mirá primero ese archivo.

    columns="auto" reparte por ancho mínimo y no necesita la variable.
*/

export const MetricGrid = ({ columns = 'auto', gap = 'md', children }) => (

    <div
        className={`${BLOCK}_grid`}
        data-columns={columns}
        data-gap={gap}
        style={columns === 'auto' ? undefined : { '--LS__metric_cols': columns }}
    >
        {children}
    </div>
);
